var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDocumentFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 48,
    viewBox: "0 0 64 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.64828 25.1977C0.787775 31.2977 0.0444719 33.8729 0.0107627 34.336C-0.121173 36.1475 0.972026 38.0177 2.62368 38.8061C3.16953 39.0666 7.19093 40.16 19.6428 43.4331C28.6103 45.7902 36.1931 47.7819 36.4935 47.8589C37.1302 48.0222 38.2551 48.0378 38.8981 47.8923C40.077 47.6255 41.3652 46.6766 41.9281 45.6602C42.0754 45.3944 42.6474 43.7664 43.1992 42.0423C43.751 40.3183 44.2274 38.8303 44.2578 38.7357C44.3103 38.5724 43.506 38.5637 28.3269 38.563C12.7624 38.5624 12.3191 38.5572 11.518 38.3685C8.58521 37.6777 6.41552 35.5691 5.55918 32.5775C5.35182 31.8532 5.34402 31.6091 5.29221 24.2677L5.23889 16.7041L2.64828 25.1977Z",
    fill: "var(--secondary-1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7871 35.4566C11.5903 35.4566 10.5661 35.0308 9.71455 34.1793C8.86301 33.3278 8.43651 32.3029 8.43506 31.1046V4.99262C8.43506 3.79582 8.86155 2.77165 9.71455 1.92011C10.5675 1.06857 11.5917 0.642076 12.7871 0.640625H25.8431L30.1951 4.99262H47.6031C48.7999 4.99262 49.8248 5.41912 50.6777 6.27211C51.5307 7.1251 51.9565 8.14927 51.9551 9.34462V31.1046C51.9551 32.3014 51.5293 33.3263 50.6777 34.1793C49.8262 35.0323 48.8013 35.4581 47.6031 35.4566H12.7871ZM34.5471 31.1046H38.8991V26.7526H43.2511V22.4006H38.8991V18.0486H43.2511V13.6966H38.8991V9.34462H34.5471V13.6966H38.8991V18.0486H34.5471V22.4006H38.8991V26.7526H34.5471V31.1046Z",
    fill: "var(--secondary-3)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.7599 41.7416C58.787 41.7416 62.8622 37.6664 62.8622 32.6393C62.8622 27.6123 58.787 23.5371 53.7599 23.5371C48.7329 23.5371 44.6577 27.6123 44.6577 32.6393C44.6577 37.6664 48.7329 41.7416 53.7599 41.7416ZM52.6933 38.3282V33.706H48.071V31.5726H52.6933V26.9504H54.8266V31.5726H59.4488V33.706H54.8266V38.3282H52.6933Z",
    fill: "var(--secondary-7)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentFilled);
export default __webpack_public_path__ + "static/media/documentFilled.b6506a73e39cfc9977d9726764d48e0d.svg";
export { ForwardRef as ReactComponent };